import { render, staticRenderFns } from "./ManterPeriodoFormacaoView.vue?vue&type=template&id=0b03f2f2"
import script from "./ManterPeriodoFormacaoView.vue?vue&type=script&lang=js"
export * from "./ManterPeriodoFormacaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports